export const creditsEmptyInfo = {
  empty_credits_before_my_portal:
    "To get credits for repairs, list parts. Visit ",
  empty_credits_after_my_portal:
    " to see your current listings or sell a part.",
  empty_credits_link_my_portal: "My Portal",
} as const;
